define(
  'modules/camera',
  [
    'jquery',
    'modules/spin-loader',
    'modules/utils',
    'modules/tracking'
  ],
  function (
    $,
    M_SpinLoader,
    M_Utils,
    M_Tracking
  ) {
    'use strict';

    var classes = {
      isHidden: 'is--hidden',
      isActive: 'is--active'
    };
    var selectors = {
      cameraToggle: '.js-camera-toggle'
    };
    var state = {
      isVisible: false,
      isEnabled: false
    };
    var $cameraToggle;


    function init () {
      getElems();
      bindEvents();
      
      M_Utils.isIE ? hideButton() : showButton();
    }

    function getElems () {
      $cameraToggle = $(selectors.cameraToggle);
    }

    function bindEvents () {
      $cameraToggle.on('click', onCameraToggleClick);

      M_Utils.addListener('TRACKINGAVAILABLE', onCameraAllowed);
    }

    function onCameraAllowed () {
      enable();
      bindPermissionChangeEvents();
    }

    function bindPermissionChangeEvents () {
      if (!navigator.permissions) { // Permissions API currently only supported in Chromium-based browsers
        return;
      }

      navigator.permissions.query({name: 'camera'}).then(function (result) {
        result.onchange = function () {
          switch (result.state) {
            case 'denied':
              disable();
              break;
            case 'prompt':
            case 'granted':
              enable();
              break;
          }
        };
      });
    }

    function onCameraToggleClick (e) {
      e.preventDefault();
      e.stopPropagation();

      state.isEnabled ? disable() : enable();

      M_Tracking.trackEvent('click-cta', 'Camera Toggle ' + (state.isEnabled ? 'On' : 'Off'));
    }

    function disable () {
      state.isEnabled = false;
      $cameraToggle.addClass(classes.isActive);

      M_SpinLoader.headTrackingDisable();
    }

    function enable () {
      state.isEnabled = true;
      $cameraToggle.removeClass(classes.isActive);

      M_SpinLoader.headTrackingEnable();
    }

    function showButton () {
      $cameraToggle.removeClass(classes.isHidden);
    }

    function hideButton () {
      $cameraToggle.addClass(classes.isHidden);
    }

    return {
      init: init,
      showButton: showButton
    }
});

